<template>
  <div>
    <input type="hidden" name="_token" :value="csrf" />
    <input v-if="this.editing" type="hidden" name="_method" value="PUT" />
    <div class="row align-items-center px-3 mb-5 mt-5 ml-3 mr-3" v-if="job_affiliation">
      <div class="card p-2 border-card shadow col-4">
          <p class="text-primary">{{ __("forms.questionsLabel.affinityPosition") }}</p>
          <p class="text-right h3">
            {{ taxRoleAffiliation }}%
          </p>
      </div>
      <div class="col-8 px-4">
        <div
            class="progress shadow mr-3"
            style="height: 2rem; border-radius: 10px"
        >
          <div
              class="progress-bar"
              role="progressbar"
              :style="{
              width: taxRoleAffiliation + '%',
              backgroundColor: colorBar,
              textAlign: 'right',
              paddingRight: 15 + 'px',
              color: 'white',
            }"
          >{{ taxRoleAffiliation }}%</div>
        </div>
      </div>
    </div>
    <div class="table--custom px-3">
      <div class="single--row single--row-head single--row-head--mini">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="single--row-info">
              Skill
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info">
              {{ __("forms.questionsLabel.requiredLevel") }}
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info">
              {{ __("forms.questionsLabel.doneLevel") }}
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-12">
            <div class="single--row-info">
              Status
            </div>
          </div>
        </div>
      </div>
      <div class="single--row single--row-input">
        <div
          class="single--row-input-content"
          v-for="(row, index) in tableDataSkillRoles"
          v-bind:key="index"
        >
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="single--row-info">
                {{ row.skillName }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                {{ row.skillRoleLevel }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info" style="padding-right: 10px; padding-left: 10px;">
                <select
                  class="form-control"
                  :disabled="level_permission['disabled']"
                  :class="level_permission['classRequired']"
                  :required="level_permission['required']"
                  :name="
                    'question[' +
                    question_survey_id +
                    '][skills_roles][' +
                    row.id +
                    ']'
                  "
                  v-model="roleSkillColors[row.id]['answer']"
                  @change="changeLevel($event, row.id)"
                >
                  <option value="null">---</option>
                  <option
                    v-for="option in levels"
                    v-bind:value="option.id"
                    v-bind:key="option.id"
                  >
                    {{ option.title }}
                  </option>
                  <option value="-99">{{ __("forms.questionsLabel.notEval") }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div class="single--row-info">
                <div v-html="roleSkillColors[row.id].delta"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row align-items-center px-3 mb-4 mt-4">
      <div class="col-10">
        <p class="h6 text-primary ml-1">  {{ __("forms.questionsLabel.personalSkill") }}</p>
      </div>
      <div class="col-2">
        <div  v-if="add_personal_skill_permission > 1">
          <button
            type="button"
            class="btn btn--green float-right mr-3"
            data-toggle="modal"
            :data-target="'#addSkillModal' + this.question_survey_id"
          >
                {{ __("misc.add") }}
          </button>
        </div>
      </div>
    </div>

    <div class="table--custom px-3 mt-3 mb-3">
      <div class="single--row single--row-head single--row-head--mini">
        <div class="row">
          <div class="col-lg-10 col-md-10 col-12">
            <div class="single--row-info">
              {{ __("forms.questionsLabel.personalSkill") }}
            </div>
          </div>

          <div class="col-lg-2 col-md-2 col-12">
            <div
              class="single--row-info border-0"
            >
              {{ __("forms.questionsLabel.doneLevel") }}
            </div>
          </div>
        </div>
      </div>
      <div class="single--row single--row-input">
        <div
          class="single--row-input-content"
          v-for="(row, index) in tableDataSkillPersonal"
          v-bind:key="index"
        >
          <div class="row">
            <div class="col-lg-10 col-md-10 col-12">
              <div
                class="single--row-info flex-row justify-content-start align-items-center pl-3"
              >
                <button
                  v-if="add_personal_skill_permission > 1"
                  class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mr-3"
                  @click="rmNewSkill(row)"
                ><i class="fas fa-trash"></i></button>

                {{ row.skillName }}
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-12">
              <div
                class="single--row-info" style="padding-right: 10px; padding-left: 10px;"
                v-if="add_personal_skill_permission > 1"
              >
                <select
                  class="form-control"
                  :disabled="level_permission['disabled']"
                  :class="level_permission['classRequired']"
                  :required="level_permission['required']"
                  :name="
                    'question[' +
                    question_survey_id +
                    '][people_skills][' +
                    row.id +
                    ']'
                  "
                  v-model="tableDataSkillPersonal[index]['answer']"
                >
                  <option value="null">---</option>
                  <option
                    v-for="option in levels"
                    v-bind:value="option.id"
                    v-bind:key="option.id"
                  >
                    {{ option.title }}
                  </option>
                </select>
              </div>
              <div class="single--row-info border-0" v-else>
                {{ levels_array[row.answer] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      :id="'addSkillModal' + this.question_survey_id"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addSkillModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 1.5rem">
          <div class="modal-header">
            <h5 class="modal-title" id="addSkillModalLabel">
              {{ __("forms.questionsLabel.addSkill") }}
            </h5>
            <button
              type="button"
              ref="addSkillCloseModal"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row py-5">
              <div class="col-6">
                <label>{{ __("forms.questionsLabel.addSPersonalkill") }}</label>
                <select class="form-control" v-model="newSkill">
                  <option
                    v-for="skill in skills"
                    :value="skill.id"
                    :key="skill.id"
                  >
                    {{ skill.name }}
                  </option>
                </select>
              </div>
              <div class="col-6">
                <a class="btn btn--green mt-4" @click="addNewSkill()">
                  <i class="fas fa-circle-plus"></i>{{ __("forms.questionsLabel.addSkill") }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.roundColor {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border-style: solid;
  border-color: black;
}
</style>

<script>
export default {
  computed: {
    colorBar() {
      let color = "";
      if (this.taxRoleAffiliation < 34) {
        color = "#F04649";
      } else if (this.taxRoleAffiliation < 67) {
        color = "#FFA800";
      } else {
        color = "#2A9D8F";
      }
      return color;
    },
  },
  created() {
    this.roleSkillColors = this.deltas["skills_roles"];

    for (let index in this.roleSkillColors) {
      this.roleSkillColors[index]["delta"] = null;
      if (this.empty_values) {
        //if empty_values == true, set temporally all results to null
        this.roleSkillColors[index]["answer"] = null;
      }
      if (this.roleSkillColors[index]["answer"] !== null)
        this.changeColorRound(index);
    }
  },
  mounted() {
    this.populateSkillTable();
    this.taxJobAffiliation();
  },
  props: {
    add_personal_skill_permission: {
      type: Number,
      required: true,
    },
    level_permission: {
      type: Object,
      required: true,
    },
    levels: {
      type: Array,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    job_affiliation: {
      type: Boolean,
      required: true,
    },
    skills: {
      type: Array,
      required: true,
    },
    levels_array: {
      type: Object,
      required: true,
    },
    levels_weight: {
      type: Object,
      required: true,
    },
    deltas: {
      type: Object,
      required: true,
    },
    colors_delta: {
      type: Object,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    model_chart: {
      type: String,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: false,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      test: "#FF0000",
      level_list: [],
      roleSkillColors: [],
      personalSkillColors: [],
      colorsRound: [],
      tableDataSkillRoles: [],
      tableDataSkillPersonal: [],
      taxRoleAffiliation: 0,
      newSkill: 0,

      //default
      userUrl: this.is_admin ? "" : "-user",
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    addNewSkill() {
      axios
        .put(
          "/add-skill-personal-table-chart/" +
            this.evaluation_chart_id +
            "/chart" ,
          {
            question_survey_id: this.question_survey_id,
            skill_id: this.newSkill,
            model_chart : this.model_chart
          },
        )
        .then((response) => {
          this.$refs.addSkillCloseModal.click();
          this.newSkill = 0;
          this.populateSkillTable();
        });
    },
    rmNewSkill(row) {
      axios
        .delete(
          "/delete-skill-personal-table-chart/" +
            this.evaluation_chart_id +
            "/chart" ,
          {
            params: {
              question_survey_id: this.question_survey_id,
              skill_id: row.id,
              model_chart : this.model_chart
            },
          },
        )
        .then((response) => {
          this.populateSkillTable();
        });
    },
    changeLevel(event, index) {
      this.changeColorRound(index);
      this.taxJobAffiliation();
    },
    taxJobAffiliation() {
      axios
          .post("/cover-role-rate", {
            arraySkillLevel: this.roleSkillColors
          })
          .then((response) => {
            this.taxRoleAffiliation = response.data.taxRoleAffiliation;
          });
    },

    populateSkillTable() {
      axios
        .get(
          "/skill-personal-table-chart/" +
            this.evaluation_chart_id +
            "/chart"  ,
          {
            params: {
              question_survey_id: this.question_survey_id,
              model_chart : this.model_chart
            },
          },
        )
        .then((response) => {
          this.tableDataSkillRoles = response.data.skills_roles;
          this.tableDataSkillPersonal = response.data.people_skills;
        });
    },

    checkUpDownDelta(index) {
      index = parseInt(index);
      let deltaN =
        parseInt(this.roleSkillColors[index]["answer"]) -
        parseInt(this.roleSkillColors[index]["required"]);
      if (deltaN === 0) {
        this.roleSkillColors[index]["delta"] = "<i class='fas fa-equals'></i>";
      }
      if (deltaN > 0) {
        this.roleSkillColors[index]["delta"] =
          "<i class='fas fa-arrow-up'></i>";
      }
      if (deltaN < 0) {
        this.roleSkillColors[index]["delta"] =
          "<i class='fas fa-arrow-down'></i>";
      }
    },
    changeColorRound(index) {

      index = parseInt(index);

      let colorRed = "#FFFFFF";
      let colorGrey = "#A8A8A8";
      let htmlDiv = "<div class='shadow' style='width: 24px;height: 24px;background-color:{#color} ;border-radius: 50%;'></div>";
      
      //not already answered
      if (this.roleSkillColors[index]["answer"] === null || this.roleSkillColors[index]["answer"] === "null") {        
        this.roleSkillColors[index]["delta"] = htmlDiv.replace("{#color}", colorRed);        
        return;
      }

      let answerWeight = this.levels_weight[this.roleSkillColors[index]["answer"]];
      let requiredWeight =this.levels_weight[this.roleSkillColors[index]["required"]];
      let deltaN = ( parseInt(answerWeight) - parseInt(requiredWeight)).toString();

      //unset
      if (this.roleSkillColors[index]["answer"] === "-99") {
        this.roleSkillColors[index]["delta"] = htmlDiv.replace("{#color}", colorGrey);
      } else {      
        let keysColor = Object.keys(this.colors_delta);
        if (keysColor.includes(deltaN)) {
          this.roleSkillColors[index]["delta"] = htmlDiv.replace("{#color}", this.colors_delta[deltaN]);          
        } else if (deltaN < 0) {
          this.roleSkillColors[index]["delta"] = htmlDiv.replace("{#color}", this.colors_delta["-10"]);
        } else {
          this.roleSkillColors[index]["delta"] = htmlDiv.replace("{#color}", this.colors_delta["10"]);          
        }
      }
    },
  },
};
</script>
